import { useEffect, useState } from "react";
import { OptionsSelect } from "../../../interface/form-base";
import { BcMultiSelectProps } from "../../../interface/props/bcmultiselect";
import {
  BCContainerTag,
  BCFieldset,
  BCSelect,
  BCSelectCont,
  BCTagCountry,
} from "../../../styled/global.styled";

const MultiSelect = ({ setValue, getValues ,field, legend, register, isRequired, watch }: BcMultiSelectProps) => {


  const [edit, setEdit] = useState(false);

  /** Estado de lista de opciones para agregar en el formulario. */
  const [options, setOptions] = useState<OptionsSelect[]>(
    field?.options as OptionsSelect[]
  );

  const fieldWach = watch(field.item)

  /** Estado de las las opciones seleccionadas */
  const [optionsSelected, setOptionsSelected] = useState<OptionsSelect[]>([]);

  useEffect(() => {
    console.log("valor del campo -->",fieldWach);
    if ((fieldWach as [string])?.length > 0) {
      setEdit(true);
      fieldWach.forEach((value: string) => {
        console.log(value);
        //addOptions(value);
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldWach])


  /** Metodo para el cambio del formulario padre */
  const changeForm = () => {
    const listOptions: string[] = [];
    optionsSelected.forEach((option: OptionsSelect) => {
      listOptions.push(option.value as string);
    });
    console.log("entro al change", listOptions);
    setValue(field.item, listOptions);
  };

  useEffect(() => {
    changeForm();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsSelected])
  
  /** Metodo para agregar la opcion al array de las opciones
   * seleccionadas en el select de opciones.
   * @param value equivale al nombre de la opcion
   */
  const addOptions = (value: string) => {
    console.log(value);
    const index = options.findIndex((i: OptionsSelect) => i.value === value);
    const option = options.find(
      (Option: OptionsSelect) => Option.value === value
    );
    const newOptions: OptionsSelect[] = [...optionsSelected];
    newOptions.push(option as OptionsSelect);
    console.log(newOptions);
    setOptionsSelected(optionsSelected => [...optionsSelected, option as OptionsSelect]);
    const selectOptions: OptionsSelect[] = [...options];
    selectOptions.splice(index, 1);
    console.log(selectOptions);
    setOptions(selectOptions);
    const select = document.getElementById(field.item) as HTMLSelectElement;
    select.selectedIndex = 0;
    changeForm();
  };

  /** Metodo para eliminar uno de los itema seleccionadas
   * y volver a agreagr al select de los items.
   * @param index es el numero de la posición de la opciona eliminar.
   */
  const deleteOptions = (index: number) => {
    const option = optionsSelected[index];
    const newOptions: OptionsSelect[] = [...optionsSelected];
    newOptions.splice(index, 1);
    setOptionsSelected(newOptions);
    const selectOptions: OptionsSelect[] = [...options];
    selectOptions.push(option);
    setOptions(selectOptions);
    const select = document.getElementById(field.item) as HTMLSelectElement;
    select.selectedIndex = 0;
    changeForm();
  };

  return (
    <BCFieldset>
      <legend>{legend}</legend>
      <div className="bc-input-group">
        <BCSelectCont>
          <label htmlFor={field.item}>{field.label}</label>
          <BCSelect
            className="bc-input"
            id={field.item}
            aria-label={field.label}
            onChange={(e) => addOptions(e.target.value)}
            disabled={options?.length > 0 ? false : true}
          >
            <option value="">Seleccione el/la {field.label}</option>
            {options?.map((option: OptionsSelect) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
          </BCSelect>
        </BCSelectCont>
      </div>
      <input type="hidden" {...register(field.item, { required: isRequired })} />
      <BCContainerTag>
        {optionsSelected.map((option: OptionsSelect, index: number) => (
          <BCTagCountry key={option.name}>
            {option.name}
            <button className="btn-clear" onClick={() => deleteOptions(index)}>
              <em className="bc-icon bc-sx">error</em>
            </button>
          </BCTagCountry>
        ))}
      </BCContainerTag>
    </BCFieldset>
  );
};

export default MultiSelect;
